module.exports = __webpack_public_path__ + "static/media/globoserv-logo.2f168e3a.png";